// Vidste du?-tekster til resultatskærmen. Håndskrevne, korte og med kilde (DESIGN.md: "Baner").
// Kun tal, som research har verificeret, og aldrig MW: spilleren skal kunne læse dem på et øjeblik.
//
// UTJEKKET: ingen af kortene er endnu faktatjekket af Energinet. Hvert kort har `checked: false`,
// og Netatlasset viser et lille UTJEKKET-mærke, indtil en fagperson har læst teksten og kilden
// og sat `checked: true`. Ret tallet eller fjern kortet hellere end at gætte.

export interface AtlasFact {
  /** Kort overskrift til Netatlas-kortet. */
  title: string;
  text: string;
  source: string;
  /** Sat til true, når en fagperson hos Energinet har tjekket tal og kilde. */
  checked: boolean;
}

export const ATLAS_FACTS: Record<string, AtlasFact[]> = {
  '01-foerste-vind': [
    {
      title: 'Sol og vind',
      text: 'I 2024 dækkede sol og vind 63 % af danskernes elforbrug. Derfor skal nettet kunne flytte strømmen derhen, hvor folk bor, også når det blæser.',
      source: 'Klima-, Energi- og Forsyningsministeriet, 2025',
      checked: false,
    },
    {
      title: 'Stormen Allan',
      text: 'Da stormen Allan ramte i oktober 2013, mistede omkring 180.000 kunder strømmen i cirka en time.',
      source: 'Ingeniøren, 2013',
      checked: false,
    },
  ],
  '02-thor-gaar-i-land': [
    {
      title: 'Thor',
      text: 'Thor ligger ud for Thorsminde, i nordenden af denne kyst. Den er Danmarks største havvindmøllepark med 72 møller. Den sendte sin første strøm i land i marts 2026.',
      source: 'Dansk Industri, 2026',
      checked: false,
    },
    {
      title: 'Kabel i jorden',
      text: 'På den nye Vestkystforbindelse lægges 26 km af ledningen i jorden som kabel, så færre master står i landskabet.',
      source: 'Danish Offshore Industry',
      checked: false,
    },
  ],
  '05-naar-vinden-sover': [
    {
      title: 'Norges batteri',
      text: 'Skagerrak-kablerne går fra Tjele ved Viborg til Kristiansand. Når vinden sover i Danmark, kan norsk vandkraft løbe den anden vej.',
      source: 'Energinet; Wikipedia: Skagerrak',
      checked: false,
    },
    {
      title: 'Kablet, der knækkede',
      text: 'En fejl på Skagerrak 4 i 2019 betød, at forbindelsen til Norge kørte med mindre kraft i månedsvis.',
      source: 'Energinet, 2020',
      checked: false,
    },
  ],
  '06-to-hjerter': [
    {
      title: 'To takter',
      text: 'Jylland og Fyn slår i takt med resten af Europa, Sjælland i takt med Norden. Kun Storebæltsforbindelsen fra 2010 binder de to sammen.',
      source: 'Energinet',
      checked: false,
    },
    {
      title: 'Svinghjul',
      text: 'Energinet har store snurrende maskiner, blandt andet i Fraugde og Herslev. Deres tunge rotorer bremser frekvensen, når et værk falder ud.',
      source: 'Ingeniøren, 2025',
      checked: false,
    },
    {
      title: 'Mørket i 2003',
      text: 'I september 2003 faldt et svensk atomkraftværk ud, og fem minutter senere kom en fejl mere. 2,4 mio. mennesker i Østdanmark sad i mørke.',
      source: 'Ingeniøren, 2003',
      checked: false,
    },
  ],
};

/** Ét faktum til banen. Seedet vælger, så samme runde altid viser det samme. */
export function atlasFact(levelId: string, seed: number): AtlasFact | null {
  const list = ATLAS_FACTS[levelId];
  if (!list || list.length === 0) return null;
  return list[Math.abs(seed) % list.length] ?? null;
}

/** Fast id for et kort, som Netatlasset gemmer: `${level}#${i}`. */
export function atlasId(levelId: string, fact: AtlasFact): string {
  const i = (ATLAS_FACTS[levelId] ?? []).indexOf(fact);
  return `${levelId}#${Math.max(0, i)}`;
}
